import { useState } from "react";
import { Button } from "@/src/components/ui/button";
import { useFilters, usePageSort } from "./state";
import { PayerType } from "./model";
import { fetch } from "@/src/lib/fetch";

export function ExportButton({ activeTab }: { activeTab: "customers" | "operators" }) {
  const { customerId, operatorId, amountFrom, amountTo, amountCurrency, bookingRef, operatorRef } = useFilters();
  const page = 1;
  const pageSize = 10000;
  const { customerSortBy } = usePageSort();
  const [loading, setLoading] = useState(false);

  const handleOnClick = async () => {
    setLoading(true);

    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: pageSize.toString(),
      orderBy: customerSortBy,
      payerType: activeTab === "customers" ? PayerType.CUSTOMER : PayerType.OPERATOR,
    });

    if (customerId) queryParams.append("customerId", customerId.toString());
    if (operatorId) queryParams.append("operatorId", operatorId.toString());
    if (amountFrom) queryParams.append("amountFrom", amountFrom.toString());
    if (amountTo) queryParams.append("amountTo", amountTo.toString());
    if (amountCurrency) queryParams.append("amountCurrency", amountCurrency.toString());
    queryParams.append("bookingRef", bookingRef ? bookingRef.toString() : "null");
    queryParams.append("operatorRef", operatorRef ? operatorRef.toString() : "null");

    const queryString = queryParams.toString();

    try {
      const blob = await fetch<Blob>(
        `/api/payment-schedule-step/export?${queryString}`,
        "GET",
        undefined,
        undefined,
        3004,
        "text/csv",
      );

      const downloadLink = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `${activeTab}_payment_schedule.csv`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
    } catch (error) {
      console.error("Error during CSV export", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="action" onClick={handleOnClick} disabled={loading}>
      {loading ? "Exporting..." : "Export"}
    </Button>
  );
}
